import React, { useEffect, useState } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter as Router, Routes, Route, Navigate, useNavigate } from 'react-router-dom';
import { Analytics } from '@vercel/analytics/react';
import { App } from './ui/App';
import TournamentDetails from './components/TournamentDetails/TournamentDetails';
import TournamentBracket from './components/TournamentBracket/TournamentBracket';
import AdminLogin from './components/Admin/AdminLogin';
import AdminLayout from './components/Admin/AdminLayout';
import AdminPage from './pages/AdminPage';
import { supabase } from './lib/supabase';
import './ui/theme.css';

// Protected Route Component
const ProtectedRoute = ({ children }: { children: React.ReactNode }) => {
  const [isLoading, setIsLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const checkAuth = () => {
      try {
        const isAuthenticated = localStorage.getItem('isAdminAuthenticated') === 'true';
        if (!isAuthenticated) {
          navigate('/admin');
        } else {
          setIsLoading(false);
        }
      } catch (error) {
        console.error('Auth check error:', error);
        navigate('/admin');
      }
    };

    checkAuth();
  }, [navigate]);

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-900">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-red-500"></div>
      </div>
    );
  }

  return <>{children}</>;
};

// Admin Routes Component
const AdminRoutes = () => (
  <Routes>
    <Route path="/" element={<AdminLogin />} />
    <Route 
      path="/dashboard" 
      element={
        <ProtectedRoute>
          <AdminLayout>
            <AdminPage />
          </AdminLayout>
        </ProtectedRoute>
      } 
    />
    <Route 
      path="*" 
      element={<Navigate to="/admin" replace />} 
    />
  </Routes>
);

// Main App Component
const Root = () => (
  <React.StrictMode>
    <Router>
      <Routes>
        <Route path="/" element={<App />} />
        <Route path="/tournament" element={<TournamentBracket />} />
        <Route path="/admin/*" element={<AdminRoutes />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
      <Analytics />
    </Router>
  </React.StrictMode>
);

createRoot(document.getElementById('root')!).render(<Root />);

